export { default as ArrowRight } from './arrow-right.svg';
export { default as Download } from './download.svg';
export { default as LinkedIn } from './linkedin.svg';
export { default as Instagram } from './instagram.svg';
export { default as Twitter } from './twitter.svg';
export { default as Quotemarks } from './quotemarks.svg';
